import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';

import { useDownloadTableModal } from '../context/DownloadTableModalContext';

const DownloadTableModalBody: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useDownloadTableModal();

  return (
    <Modal.Body>
      <div className="nk-modal">
        <div className="row">
          <div className="col-6">
            <div className="custom-control custom-checkbox">
              <input
                type="checkbox"
                className="custom-control-input"
                id="pdf-format"
                checked={data.pdfFormat}
                onChange={actions.handleChangePdfFormat}
              />
              <label className="custom-control-label" htmlFor="pdf-format">
                {t('PdfFormat')}
              </label>
            </div>
          </div>

          <div className="col-6">
            <div className="custom-control custom-checkbox">
              <input
                type="checkbox"
                className="custom-control-input"
                id="excel-format"
                checked={data.excelFormat}
                onChange={actions.handleChangeExcelFormat}
              />
              <label className="custom-control-label" htmlFor="excel-format">
                {t('ExcelFormat')}
              </label>
            </div>
          </div>
        </div>
      </div>
    </Modal.Body>
  );
};

export default DownloadTableModalBody;
